export default "__VITE_ASSET__DLYvKr9q__"